import { Component, OnInit } from '@angular/core';
import { PROVINCES } from '../../../data/provinces';
import { Client } from '../../../../classes/Client';
import { Supplier } from '../../../../classes/Supplier';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { AlertsService } from '../../../services/alerts.service';

@Component({
  selector: 'app-edit-client',
  templateUrl: './edit-client.component.html',
  styleUrls: ['./edit-client.component.css']
})
export class EditClientComponent implements OnInit {

  provinces = PROVINCES;
  isSubmitButtonDisabled: boolean = false;
  id: number;
  contentVisible: boolean = false;
  editClient: Client = new Client( );
  addSupplierButtonDisabled: boolean = true;
  suppliers: Supplier[] = [];
  selectedSuppliers: any = {};

  hasNotes: boolean = false;
  notes: any;
  isRequiredNotesField: boolean = true;
  isNotesWasEdited: boolean = false;
  
  customAdmins = [];

  availableRoles: string[] = [ 'admin', 'sales', 'manager' ];
  isAvailable: boolean = true;

  selectParams: any = {

    referredBy: {
      id: 'inputReferredBy',
      isRequired: true,
      change: ( event ) => { this.editClient.referredBy = event.value; },
      options: [ { text: '', value: '' } ]
    },
    
    billingState: {
      id: 'inputBillingState',
      isRequired: true,
      change: ( event ) => {
        this.editClient.BillingState = event.value;
      },
      options: [ { text: '', value: '' } ]
    },

    shippingState: {
      id: 'inputShippingState',
      isRequired: true,
      change: ( event ) => {
        this.editClient.ShippingState = event.value;
      },
      options: [ { text: '', value: '' } ]
    },
    
    suppliers: []

  }

  constructor ( 
    private route: ActivatedRoute,
    private model: ModelService,
    public global: GlobalService,
    private alerts: AlertsService,
    private loginService: LoginService ) { 
    this.global.setDocumentTitle( 'Edit Client' ); 
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
    this.editClient.suppliers = [{
      supplier_id: '',
      supplierAccountNumber: ''
    }];

    this.provinces.forEach( _state => {
      this.selectParams.billingState.options.push( { text: _state.long, value: _state.short } );
      this.selectParams.shippingState.options.push( { text: _state.long, value: _state.short } );
    });
  }

  ngOnInit ( ) { 
    this.route.params.subscribe(params => {
      this.id = +params['id'];
      
      this.model.getCustomAdmins( ( customAdmins ) => { 
        this.customAdmins = customAdmins;
        customAdmins.forEach( _admin => {
          this.selectParams.referredBy.options.push( { text: _admin.firstName+' '+_admin.secondName ,value: _admin.id } );
        });
      });

      this.model.getSuppliersData( ( spData ) => {
        this.suppliers = spData;
        this.model.getClientDataByID( this.id, ( client ) => {
          this.contentVisible = true;
          client.notes = '';
          this.editClient = client;
          this.editClient.id = this.id;
          this.getNotes( );
          this.checkSupplier( );
        });
      }, { 'sorting': 'name' });
    });
  }

  getNotes ( ) {
    this.model.getNotes( 'client', this.id, ( notes ) => {
      this.notes = notes;
      this.hasNotes = notes.length != 0;
    });
  }

  addNote ( ) {
    this.model.addNote( 'client', this.id, this.editClient.Notes, ( response ) => {
      this.getNotes( );
      this.isRequiredNotesField = false;
      this.isNotesWasEdited = true;
    });
  }

  trackByIndex( index: number, obj: any ): any {
    return index;
  }


  addSupplier ( ) {
    this.editClient.suppliers.push({
      supplier_id: '',
      supplierAccountNumber: ''
    });
    this.checkSupplier( );
  }

  checkSupplier ( fromInput?:boolean ) {
    let i;
    this.addSupplierButtonDisabled = false;
    this.selectedSuppliers = {};
    for ( i = 0; i < this.editClient.suppliers.length; ++i ) {
      this.selectedSuppliers[this.editClient.suppliers[i].supplier_id] = i;
      if ( !this.editClient.suppliers[i].supplier_id || this.editClient.suppliers[i].supplierAccountNumber == '' ) this.addSupplierButtonDisabled = true;
    }

    if ( fromInput != true ) this.generateSuppliersSelectParams( );

  }

  generateSuppliersSelectParams (  ) { 

    this.selectParams.suppliers = [];

    this.editClient.suppliers.forEach( ( _cSupplier, ind ) => {

      let _SO = {
        isRequired: true,
        change: ( event ) => {
          this.editClient.suppliers[ind].supplier_id = event.value;
          this.checkSupplier( );
        },
        options: [ ],
        selectedValue: this.editClient.suppliers[ind].supplier_id,
        elementID: ''
      };

      let _options = [{ text: '', value: '' }];

      if ( ind == 0 ) _SO.elementID = 'selectSupplier';

      this.suppliers.forEach( _supplier => {
        if ( !( ( this.selectedSuppliers[_supplier.id] || this.selectedSuppliers[_supplier.id] == 0 ) && this.selectedSuppliers[_supplier.id] !== ind ) ) {
          _options.push( { text: _supplier.name, value: _supplier.id } );
        }
      });

      _SO.options = _options;

      this.selectParams.suppliers.push( _SO );

    });

  }


  removeSupplier ( _i: number ) {
    this.editClient.suppliers.splice( _i, 1 );
    this.checkSupplier( );
  }

  showHistory ( ) { this.global.changeHPVisibility( true ); }

  successCallback ( ) {
    this.global.defaultSuccessMessage({ 
      html: 'Client information has been updated successfully', 
      redirect: '/clients-list' 
    });
  }


  errorCallback ( message ) {
    let data = {
      messageType: 'error',
      message: message || 'We got some error here...',
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.global.defaultErrorCallback( message, false );
    this.isSubmitButtonDisabled = false;

  }

  submitForm ( ) {

    if ( this.editClient.SameAsBillingAddress ) {
      this.editClient.ShippingStreet  = this.editClient.BillingStreet;
      this.editClient.ShippingCity    = this.editClient.BillingCity;
      this.editClient.ShippingState   = this.editClient.BillingState;
      this.editClient.ShippingZipCode = this.editClient.BillingZipCode;
      this.editClient.ShippingCountry = this.editClient.BillingCountry;
    }

    this.isSubmitButtonDisabled = true;
    this.model.editClient( this.editClient, ( response ) => {
      let _answer = response.json( ).answer;
      
      if ( _answer == 'success' ) this.successCallback( );
      else this.errorCallback( _answer );
    });
    return false;
  }

  cancelSubmit ( ) {
    this.global.redirect( '/clients-list' );
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/clients/edit-client/edit-client.component.ts